export default __webpack_public_path__ + "assets/models/06a09770791315f6607541aa08e81cd8.glb";